module.exports = __webpack_public_path__ + "static/media/insta-phone.12ed0d77.png";